angular.module('st')
    .filter('startFrom', function() {
        return function(input, start) {
            start = +start;
            return input.slice(start);
        };
    })
    .controller('crewardsHistoryController', [
        '$rootScope', '$scope', '$http', '$sce', '$timeout', '$filter', '$q',
        function($rootScope, $scope, $http, $sce, $timeout, $filter, $q) {
            var ctrl = this;
            ctrl.loadingmore = false;
            ctrl.loadedAll = false;
            ctrl.loadAllError = '';
            ctrl.filterBy = '';
            ctrl.filterByUpcoming = '';
            ctrl.filterByPast = '';

            $scope.currentPage = 1;
            $scope.pageSize = 10;

            // scroll to top on page change?
            // $scope.$watch('currentPage', function(newValue, oldValue) {
            //     if (newValue != null && newValue != undefined && (newValue !== oldValue)) {
            //         $('html, body').animate({ scrollTop: $(".history").offset().top}, 1000);
            //     }
            // });

            $scope.$watch('orderBy', function(newValue, oldValue) {
                //console.log(newValue, oldValue);
                if (newValue != null && newValue != undefined && (newValue !== oldValue)) {
                    $scope.currentPage = 1;
                }
            });

            // $scope.$watch('ctrl.filteredTransactions', function(newValue, oldValue) {
            //     $scope.currentPage = 1;
            //     if (newValue) {
            //         $scope.lastPage = Math.ceil(ctrl.filteredTransactions.length / $scope.pageSize);
            //     }
            // });

            //get seats for upcoming showtimes
            ctrl.getSeatsForFirstOrders = function() {
                var howManyOrdersToGet = 3;
                var ordersGottenSoFar = 0;

                if (!ctrl.filteredUpcomingTransactions) {
                    return;
                }

                for(var i = 0; i < ctrl.filteredUpcomingTransactions.length; i++) {
                    //stop once 3 orders have been retrieved
                    if (ordersGottenSoFar >= 3 ) { break; }

                    if (ctrl.filteredUpcomingTransactions && ctrl.filteredUpcomingTransactions.length) {
                        if (ctrl.filteredUpcomingTransactions[i] && ctrl.filteredUpcomingTransactions[i].bookingId && ctrl.filteredUpcomingTransactions[i].vistaTransactionId) {
                            if (ctrl.filteredUpcomingTransactions[i].seatDetail || ctrl.filteredUpcomingTransactions[i].isGetty || ctrl.filteredUpcomingTransactions[i].noSeats || ctrl.filteredUpcomingTransactions[i].gettingMoreDetails) {
                                //if already getting info or has seat info don't load.
                            } else {
                                ctrl.getMoreDetails(ctrl.filteredUpcomingTransactions[i]);
                                ordersGottenSoFar++;
                            }
                        }
                    }
                }
            }

            ctrl.SetModel = function(data) {
                $scope.model = data;
                $scope.model.transactions = $scope.model.transactions || [];

                const now = new Date(); // Get the current date and time

                $scope.model.upcomingShowtimeTransactions = $scope.model.transactions.filter(event => new Date(event.showtime) >= now);
                $scope.model.pastTransactions = $scope.model.transactions.filter(event => new Date(event.showtime) < now);

                $scope.lastPage = Math.ceil($scope.model.transactions.length / $scope.pageSize);

                $timeout(function() {
                    ctrl.getSeatsForFirstOrders();
                }, 1000);

                ctrl.resolveSharedTickets($scope.model.transactions);
            }

            // Lazily resolve WHO booked each "Shared VIP Ticket" row. The server already flagged the
            // rows (row.sharedVipTicket); this fills in row.sharedVipBookedByName when the booker is a
            // linked/household member. One round trip for the whole page; failures/unknowns just leave
            // the generic badge in place.
            ctrl.resolveSharedTickets = function(transactions) {
                if (!transactions || !transactions.length) { return; }

                var ids = transactions
                    .filter(function(t) { return t.sharedVipTicket && t.vistaTransactionId; })
                    .map(function(t) { return t.vistaTransactionId; })
                    .filter(function(v, i, self) { return self.indexOf(v) === i; });

                if (!ids.length) { return; }

                $http.post('/rpc/vip-history/resolve-shared-bookers', { VistaTransactionIds: ids })
                    .then(function(response) {
                        var res = response && response.data;
                        if (typeof res === 'string') { try { res = JSON.parse(res); } catch (e) { res = null; } }
                        if (!res) { return; }

                        // Match AssociatedMembers RPC shape (.data), but tolerate .ResponseData too.
                        var map = res.data || res.Data || res.ResponseData;
                        if (!map) { return; }

                        transactions.forEach(function(t) {
                            if (t.sharedVipTicket && t.vistaTransactionId != null) {
                                var name = map[t.vistaTransactionId];
                                if (name == null) { name = map[String(t.vistaTransactionId)]; }
                                if (name) { t.sharedVipBookedByName = name; }
                            }
                        });
                    })
                    .catch(function() { /* leave the generic "Shared VIP Ticket Used" badge */ });
            }

            ctrl.GetLocations = function(transactions) {
                var locArray = transactions.map(function(a) { return a.locationName; });
                distinctArray = locArray.filter(function(value, index, self) { return self.indexOf(value) === index; }).sort();

                return distinctArray;
            }

            ctrl.showOrderBarcode = function(id) {
                $('#js-barcode-modal').modal({ show: true, backdrop: 'static', keyboard: false });
                JsBarcode("#barcodemodal", id, {
                    lineColor: "#000000",
                });
            }

            ctrl.IsTransactionVisible = function(index) {
                if (ctrl.filteredPastTransactions && ctrl.filteredPastTransactions.length <= $scope.pageSize) {
                    return true;
                } else {
                    var lowerLimit = ($scope.currentPage - 1) * $scope.pageSize;
                    var upperLimit = ($scope.currentPage - 1) * $scope.pageSize + $scope.pageSize;

                    return index >= lowerLimit && index < upperLimit;
                }
            }

            ctrl.getMoreDetails = function(item) {
                if (item.gettingMoreDetails) {
                    return;
                }

                item.gettingMoreDetails = true;

                //var cinemaId = "";
                //var cinemaList = [{"id": "002","name": "GR North"}, {"id": "003","name": "Crossroads"}, {"id": "004","name": "GR South"}, {"id": "005","name": "Rivertown"}, {"id": "006","name": "Lansing"}, {"id": "007","name": "Benton"}, {"id": "008","name": "Mt Pleasant"}, {"id": "009","name": "Carousel"}, {"id": "011","name": "Getty"}, {"id": "012","name": "Meridian Mall"}, {"id": "013","name": "Studio Park/MT"}];
                //var lowercaseCinema = item.locationName.toLowerCase().trim();

                //for(var i = 0; i < cinemaList.length; i++) {
                //    var cinemaParts = cinemaList[i].name.toLowerCase().split(" ");
                //    for(var j = 0; j < cinemaParts.length; j++) {
                //        var part = cinemaParts[j].trim();
                //        if (lowercaseCinema.includes(part)) {
                //            cinemaId = cinemaList[i].id;
                //            break;
                //        }
                //    }
                //}

                //if (cinemaId === "011") {
                //    item.isGetty = true;
                //    item.gettingMoreDetails = false;
                //    return;
                //}

                getMoreDetailsTransactions(item.vistaTransactionId, item.bookingId)
                    .then(function(response) {
                        //console.log(response);
                        if (response && response.data) {
                            ctrl.loadingmore = false;
                            var r = response.data;
                            var p = JSON.parse(r);
                            var t = p.ResponseData;

                            if (t) {
                                var seatList = t.Seats.join(", ");
                                if (!seatList && !t.Screen) {
                                    item.noSeats = true;
                                } else {
                                    item.seatDetail = { screen: t.Screen, seats: seatList };
                                }
                            } else {                                
                                item.noSeats = true;
                            }
                        }
                    })
                    .catch(function(response) {})
                    .finally(function(response) {
                        item.gettingMoreDetails = false;
                    });
                
            }

            ctrl.SelectUpdated = function(selectClass) {
                var text = $('select.' + selectClass + '>option:selected').html();
                var numLetters = text.length;
                var width = 100 + text.length * 7;
                var cssWidth = $(window).width() > 768 ? 192 : 159;
                width = width > cssWidth ? width : cssWidth;

                $('select.' + selectClass).css('width', width + 'px');
                $scope.currentPage = 1;

                //just do show more logic on past pages, if we need this for upcoming then copy/paste the logic again for that value of filterByUpcoming
                if (ctrl.filterByPast && ctrl.filterByPast !== 'all') {
                    var locationFilteredItems = $scope.model.transactions.filter(x => x.locationName == ctrl.filterByPast).length;
                    $scope.lastPage = Math.ceil(locationFilteredItems / $scope.pageSize);
                } else {
                    $scope.lastPage = Math.ceil($scope.model.transactions.length / $scope.pageSize);
                }
            }

            ctrl.loadalltransactions = function() {
                if (ctrl.loadingmore) {
                    return;
                }

                ctrl.loadingmore = true;
                ctrl.loadAllError = '';
                getAllTransactions()
                    .then(function(response) {
                        if (response && response.data) {
                            ctrl.loadingmore = false;
                            var r = response.data;
                            var p = null;
                            try { p = typeof r === 'string' ? JSON.parse(r) : r; } catch (e) { p = null; }

                            // Server now returns { success: false, message } on failure (was an empty string we ignored).
                            if (!p || p.success === false) {
                                ctrl.loadAllError = (p && p.message) || "We couldn't load your full history right now. Please try again in a few minutes.";
                                return;
                            }

                            var t = p.items;

                            // Loaded fine but nothing more to show: hide the button instead of leaving it dead.
                            if (!t || !t.length) {
                                ctrl.loadedAll = true;
                                return;
                            }

                            if (t && t.length) {
                                $scope.model.transactions = t || [];

                                const now = new Date(); // Get the current date and time

                                $scope.model.upcomingShowtimeTransactions = $scope.model.transactions.filter(event => new Date(event.showtime) >= now);
                                $scope.model.pastTransactions = $scope.model.transactions.filter(event => new Date(event.showtime) < now);

                                //reset filter on load more
                                ctrl.filterBy = 'all';
                                ctrl.filterByUpcoming = 'all';
                                ctrl.filterByPast = 'all';

                                if (ctrl.filterByPast && ctrl.filterByPast !== 'all') {
                                    var locationFilteredItems = $scope.model.transactions.filter(x => x.locationName == ctrl.filterBy).length;
                                    $scope.lastPage = Math.ceil(locationFilteredItems / $scope.pageSize);
                                } else {
                                    $scope.lastPage = Math.ceil(t.length / $scope.pageSize);
                                }
                                $scope.currentPage = 1;

                                ctrl.resolveSharedTickets($scope.model.transactions);

                                $('html, body').animate({ scrollTop: $(".tab-configurator").offset().top }, 1000);
                                ctrl.loadedAll = true;
                            }
                        }
                    })
                    .catch(function(response) {
                        ctrl.loadAllError = "We couldn't load your full history right now. Please try again in a few minutes.";
                    })
                    .finally(function(response) {
                        ctrl.loadingmore = false;
                    });
            }


            function getAllTransactions() {
                var config = {
                    params: {}
                };
                var deferred = $q.defer();
                
                $http.get("/rpc/membership/account/history/all", config).then(deferred.resolve);
                return deferred.promise;
            }

            function getMoreDetailsTransactions(transactionidparam, cinemaidparam) {
                transactionidparam = transactionidparam || "";
                cinemaidparam = cinemaidparam || "";

                var config = {
                        transactionid: transactionidparam,
                        bookingid: cinemaidparam
                };
                var deferred = $q.defer();
                
                $http.post("/rpc/membership/account/seatandcinema", config).then(deferred.resolve);
                return deferred.promise;
            }
        }
    ]);